export const intentMap = {
    intro: [
        "who are you",
        "about yourself",
        "about you",
        "do you do",
        "introduce yourself",
        "yourself"
    ],
    experience: [
        "experience",
        "work experience",
        "past experience",
        "background",
        "career history",
        "work history"
    ],
    skills: [
        "skills",
        "technologies",
        "tech stack",
    ],
    codingPhilosophy: [
        "coding philosophy",
        "philosophy of coding",
        "coding approach",
        "work style",
        "working style",
        "approach to work",
        "work approach",
        "work preference",
        "work environment",
        "work habits",
        "work routine"
    ],
    projects: [
        "have you built",
        "did you make",
        "your work",
        "your projects",
        "portfolio",
        "projects",
        "built anything",
        "any projects",
        "current projects",
        "ongoing projects",
        "active projects"
    ],
    programmingLanguages: [
        "programming languages",
        "coding languages",
        "languages do you code",
        "languages do you program",
    ],
    spokenLanguages: [
        "spoken languages",
        "what languages do you speak",
    ],
    manga: ["manga", "you read"],
    anime: ["anime", "watching anime"],
    music: ["music", "bands", "you listen to", "favorite music"],
    food: ["food", "cuisine", "you eat", "favorite food"],
    gaming: ["games", "gaming", "video games", "play games", "console"],
    education: ["education", "study", "school", "university", "degree"],
    kids: ["kids", "children", "family"],
    location: ["you live", "where are you", "location"],
    workspace: ["workspace", "office", "desk"],
    beverages: ["drink", "coffee", "tea", "beverage"],
    tools: [
        "development tools",
        "coding tools",
        "preferred tools",
        "editor",
        "ide",
        "what tools",
        "your tools",
    ],
    frameworks: [
        "framework",
        "library",
        "preferred framework"
    ],
    blockchain: [
        "blockchain",
        "web3",
        "smart contract",
        "nft"
    ],
    dailyLife: [
        "daily routine",
        "typical day",
        "day to day",
        "do daily",
        "spend your day",
        "your day",
        "lifestyle"
    ],
    hobbies: [
        "hobbies",
        "interests",
        "you fancy",
        "you like",
        "you enjoy",
        "for fun",
        "free time"
    ],
    digitalArt: [
        "digital art",
        "artwork",
        "art",
        "artstation"
    ],
    homeProjects: [
        "home projects",
        "projects at home",
        "personal projects"
    ],
    workHistory: [
        "work history",
        "career history",
        "professional experience",
    ],
    openSource: [
        "open source",
        "open-source projects",
        "open-source contributions"
    ],
    community: [
        "community",
        "community involvement",
        "community participation",
        "communities"
    ],
    certifications: [
        "certifications",
        "professional certifications",
        "certification"
    ],
    homeOffice: [
        "home office",
        "home-based office",
        "home workspace",
    ],
    social: [
        "social",
        "connect",
        "contact",
        "social media",
        "social presence",
        "social accounts",
        "social platforms",
    ]
};